import React, { useRef, useState } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import Alert from '@material-ui/lab/Alert';
import { useDispatch, useSelector } from "react-redux";

import * as LoginActions from '../actions/Login';

export default function LoginDialog() {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');

  // connect to redux
  let errors = useSelector(state => state.login.errors);
  let open = useSelector(state => state.login.open);
  let codeRequested = useSelector(state => state.login.codeRequested);
  let inProgress = useSelector(state => state.login.inProgress);
  let success = useSelector(state => state.login.success);

  const dispatch = useDispatch();
  const onClose = () => dispatch(LoginActions.closeLoginDialog());
  const onRequestCode = (phone,resend) => dispatch(LoginActions.requestLoginCode(phone,resend));

  const phoneKeyPress = (e) => {
    if(e.key === 'Enter') {
      onRequestCode(phone, false);
    }
  }

  const codeKeyPress = (e) => {
    if(e.key === 'Enter') {
      dispatch(LoginActions.doLogin(code));
    }
  }

  return (
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={onClose}
        aria-labelledby="login-dialog-title"
      >
        <DialogTitle id="login-dialog-title">Login</DialogTitle>
        <DialogContent>
          <DialogContentText component='div'>
            <div>
              { success ? (<Alert style={{marginBottom: 20}} severity="success">Successfully logged in</Alert>) : '' }
              <TextField type='text'
                autoFocus
                value={phone}
                onChange={(evt) => setPhone(evt.target.value)}
                fullWidth
                required
                error={typeof errors['phone'] !== 'undefined'}
                helperText={errors['phone'] ? errors['phone'] : ''}
                id="phone"
                label="Phone number"
                variant="outlined"
                onKeyPress={phoneKeyPress}
              />
            </div>
            <div style={{marginTop: 10}}>
              { codeRequested ?
              (
                <>
                  <TextField type='text'
                    autoFocus
                    value={code}
                    onChange={(evt) => setCode(evt.target.value)}
                    fullWidth
                    required
                    error={typeof errors['code'] !== 'undefined'}
                    helperText={errors['code'] ? errors['code'] : ''}
                    id="code"
                    label="Code from SMS"
                    variant="outlined"
                    onKeyPress={codeKeyPress}
                  />
                  <Button style={{textTransform: 'none', textDecoration: 'underline'}} size='small' onClick={() => onRequestCode(phone, true)}>I didn't receive the code</Button>
                </>
              )
              :
              (<Button onClick={() => onRequestCode(phone, false)} color="primary" variant="contained">Request code</Button>)
              }
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="inherit">
            Close
          </Button>
          <Button variant="contained" disabled={inProgress || (!codeRequested)}
            onClick={() => dispatch(LoginActions.doLogin(code))}
            color="primary"
            autoFocus>
            Login
          </Button>
        </DialogActions>
        {inProgress ? <LinearProgress /> : '' }
      </Dialog>
  );
}
